import { z } from 'zod';
export const icalCalendarSettingsSchema = z.object({
    userId: z.string(),
    practitioners: z.array(z.object({ id: z.string(), name: z.string() })),
    googleLinked: z.boolean(),
    enabled: z.boolean(),
    feedUrl: z.string().nullable(),
    meetAccount: z
        .object({ id: z.string(), email: z.string(), isActive: z.boolean() })
        .nullable(),
    canConnectMeet: z.boolean(),
    treatwellAvailable: z.boolean(),
    sources: z.array(z.object({
        id: z.string(),
        name: z.string(),
        kind: z.enum(['ical', 'treatwell']),
        lastSyncAt: z.string().nullable(),
        lastError: z.string().nullable(),
        email: z.string().nullable(),
    })),
});
//# sourceMappingURL=calendar-ical.js.map